import { GameLevelEnum, Weekday } from '@core-http';
import { GetAlertsSettingsQueryResult } from '../handlers';

export const DEFAULT_ALERTS_SETTINGS: GetAlertsSettingsQueryResult = {
  isEnabled: false,
  coordinates: null,
  maxDistanceMeters: 25000,
  time: { hoursMin: 0, hoursMax: 24 },
  gameLevel: [
    GameLevelEnum.BEGINNER,
    GameLevelEnum.INTERMEDIATE_BEGINNER,
    GameLevelEnum.INTERMEDIATE,
    GameLevelEnum.ADVANCED,
    GameLevelEnum.MIXED
  ],
  specificWeekdays: Object.values(Weekday)
};
